<template>
  <div class="main-content">
    <avue-crud
      ref="crud"
      :data="tableData"
      :option="option"
      :table-loading="showLoading"
      :page.sync="page"
      @on-load="onLoad"
      @selection-change="selectionChange"
    >
      <template #header>
        <div>
          <div class="flex flex-wrap align-items marginBottom20">
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >固件ID :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.firmwareId"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >固件名称 :
              </span>
              <div class="width300">
                <el-input
                  v-model="searchData.name"
                  placeholder="请输入"
                  clearable
                  maxlength="50"
                ></el-input>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >升级方式 :
              </span>
              <div class="width300">
                <el-select
                  class="width250"
                  v-model="searchData.upgradeWay"
                  clearable
                >
                  <el-option
                    v-for="(i, index) in OUpgradeMethod"
                    :value="i.value"
                    :label="i.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >升级范围 :
              </span>
              <div class="width300">
                <el-select
                  class="width250"
                  v-model="searchData.upgradeScope"
                  clearable
                >
                  <el-option
                    v-for="(i, index) in OUpgradeScope"
                    :value="i.value"
                    :label="i.label"
                    :key="index"
                  ></el-option>
                </el-select>
              </div>
            </div>
            <div class="flex align-items marginRight10 marginBottom10">
              <span class="span marginRight10 width80 textAlignRight"
                >时间 :
              </span>
              <div class="width300">
                <el-date-picker
                  v-model="searchData.createTime"
                  type="daterange"
                  range-separator="至"
                  start-placeholder="开始日期"
                  end-placeholder="结束日期"
                  :clearable="true"
                >
                  <!-- @change="handleSearch" -->
                </el-date-picker>
              </div>
            </div>
            <el-button
              size="medium"
              type="primary"
              @click="handleSearch"
              style="margin-bottom: 10px"
              class="marginLeft10"
              >搜索</el-button
            >
            <el-button
              size="medium"
              type="info"
              @click="handleReset"
              class="marginLeft10"
              style="margin-bottom: 10px"
              >重置</el-button
            >
            <div class="flex align-items marginRight10">
              <el-button
                size="medium"
                type="primary"
                class="marginLeft10"
                style="margin-bottom: 10px"
                @click="handleCreate('', 'add')"
                >新增</el-button
              >
            </div>
            <div class="flex align-items marginRight10">
              <el-button
                type="danger"
                size="medium"
                style="margin-bottom: 10px"
                @click="handleDelete([...selectedRowKeys])"
                >删除</el-button
              >
            </div>
          </div>
        </div>
      </template>
      <template slot="productCategory" slot-scope="{ row }">
        <div>
          {{
            row.productSeries +
              "-" +
              row.productCategory +
              "-" +
              row.productSubCategory
          }}
        </div>
      </template>
      <template slot="hardwareVersion" slot-scope="{ row }">
        <div>
          {{
            row.hardwarePcb +
              row.hardwareVersion +
              row.hardwareSubVersion +
              row.hardwareMcu +
              row.hardwareBrand +
              row.hardwareBrandSubModel
          }}
        </div>
      </template>
      <template slot="softwareVersion" slot-scope="{ row }">
        <div>
          {{ row.softwareData + row.softwareVersion + row.softwareSubVersion }}
        </div>
      </template>
      <template slot="upgradeWay" slot-scope="{ row }">
        <div>
          {{
            row.upgradeWay == EUpgradeMethod.remind
              ? MUpgradeMethod[row.upgradeWay]
              : row.upgradeWay == EUpgradeMethod.becomeSilent
              ? MUpgradeMethod[row.upgradeWay]
              : ""
          }}
        </div>
      </template>
      <template slot="upgradeScope" slot-scope="{ row }">
        <div>
          {{
            row.upgradeScope == EUpgradeScope.model
              ? MUpgradeScope[row.upgradeScope]
              : row.upgradeScope == EUpgradeScope.device
              ? MUpgradeScope[row.upgradeScope]
              : row.upgradeScope == EUpgradeScope.gateway
              ? MUpgradeScope[row.upgradeScope]
              : ""
          }}
        </div>
      </template>
      <template slot="menu" slot-scope="{ row }">
        <el-button type="text" size="mini" @click="handleCreate(row, 'edit')"
          >编辑</el-button
        >
        <el-button
          type="text"
          size="mini"
          @click="handleDelete([row])"
          style="color:  #ff001f!important"
          >删除</el-button
        >
      </template>
    </avue-crud>
    <el-dialog
      v-if="dialogVisible"
      title=""
      :visible.sync="dialogVisible"
      width="48%"
      :before-close="handleClose"
      v-loading="dialogLoading"
      :close-on-click-modal="false"
    >
      <div class="fault_box">
        <div class="fault_box_label">故障录波</div>
        <el-select v-model="faultRecording" placeholder="请选择">
          <el-option
            v-for="item in [1, 2, 3, 4, 5]"
            :key="item"
            :label="item"
            :value="item"
          >
          </el-option>
        </el-select>
        <el-button
          class="marginLeft10 marginRight20"
          type="primary"
          :loading="showLoadingForm"
          @click="submit(form)"
          >确认</el-button
        >
        <div class="marginRight10">故障原因：{{ faultReason }}</div>
        <div class="marginRight10">故障相别：{{ faultDistinction }}</div>
        <div>故障时间：{{ faultTime }}</div>
      </div>
      <div class="flex_echarts">
        <div class="title_left">
          <div class="left_name">Ua</div>
          <div class="left_name">Ub</div>
          <div class="left_name">Uc</div>
          <div class="left_name">Ia</div>
          <div class="left_name">Ib</div>
          <div class="left_name">Ic</div>
          <div class="left_name">In</div>
          <div class="left_name">IL</div>
        </div>
        <div class="echarts_left">
          <Echarts
            :funcData="funcData"
            :funcDataOne="funcDataOne"
            :funcDataTwo="funcDataTwo"
            :funcDataThree="funcDataThree"
            :funcDataFour="funcDataFour"
            :funcDataFive="funcDataFive"
            :funcDataSix="funcDataSix"
            :funcDataSeven="funcDataSeven"
            :funcDataEight="funcDataEight"
          />
        </div>
      </div>
      <div style="text-align: center; margin-top: 30px">
        <el-button class="marginLeft10" type="" @click="dialogVisible = false"
          >取消</el-button
        >
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { firmwareList, firmwareDelete } from "@/api/upgrade/firmware";
import dayjs from "dayjs";
import {
  EUpgradeMethod,
  MUpgradeMethod,
  OUpgradeMethod,
  EUpgradeScope,
  MUpgradeScope,
  OUpgradeScope,
} from "@/enums/beCurrent/EBeCurrent";
import Echarts from "@/components/echarts/echartsFunc";

export default {
  name: "index",
  components: {
    Echarts,
  },
  data() {
    return {
      EUpgradeMethod: EUpgradeMethod,
      MUpgradeMethod: MUpgradeMethod,
      OUpgradeMethod: OUpgradeMethod,
      EUpgradeScope: EUpgradeScope,
      MUpgradeScope: MUpgradeScope,
      OUpgradeScope: OUpgradeScope,
      searchData: {
        title: "",
        createTime: "",
        userId: this.$route.query.id || "",
      },
      page: {
        total: 0,
        currentPage: 1,
      },
      tableData: [],
      showLoading: false,
      showLoadingForm: false,
      dialogVisible: false,
      selectedRowKeys: [], //表格勾选中的数据
      option: {
        title: "",
        titleSize: "h3",
        card: false,
        border: true,
        header: false,
        stripe: false, // 显示斑马纹
        showHeader: true, // 显示表头
        index: false, // 显示索引
        indexLabel: "序号", // 索引文字
        size: "small",
        page: true, // 显示分页
        align: "center",
        menuAlign: "center",
        menuType: "text",
        editBtn: false,
        delBtn: false,
        selection: true,
        reserveSelection: true,
        selectionFixed: true,
        tip: false,
        column: [
          {
            label: "ID",
            prop: "firmwareId",
          },
          {
            label: "固件名称",
            prop: "name",
          },
          {
            label: "产品类型",
            prop: "productCategory",
          },
          {
            label: "硬件版本",
            prop: "hardwareVersion",
          },
          {
            label: "软件版本",
            prop: "softwareVersion",
          },
          {
            label: "升级方式",
            prop: "upgradeWay",
          },
          {
            label: "升级范围",
            prop: "upgradeScope",
          },
          {
            label: "升级设备ID",
            prop: "deviceIdsStr",
          },
          {
            label: "版本描述",
            prop: "versionDesc",
          },
          {
            label: "创建时间",
            prop: "createTime",
          },
        ],
      },
      selectedRowKeys: [], //表格勾选中的数据
    };
  },
  created() {},
  methods: {
    onLoad() {
      this.showLoading = true;
      const searchData = {
        ...this.searchData,
      };
      if (this.searchData.createTime) {
        searchData.createTimeStart = dayjs(
          this.searchData.createTime[0]
        ).format("YYYY-MM-DD 00:00:00");
        searchData.createTimeEnd = dayjs(this.searchData.createTime[1]).format(
          "YYYY-MM-DD 23:59:59"
        );
      }
      delete searchData.createTime;
      firmwareList({
        page: this.page.currentPage,
        size: this.page.pageSize,
        ...searchData,
      }).then((res) => {
        this.showLoading = false;
        if (res.code === 200) {
          this.tableData = res.data.records;
          this.page.total = res.data.total;
        }
      });
    },

    // 查询
    handleSearch() {
      // console.log('查询')
      this.page.currentPage = 1;
      this.onLoad();
    },
    // 重置
    handleReset() {
      // console.log('重置')
      this.searchData = {};
      this.page.currentPage = 1;
      this.onLoad();
    },

    //输入
    salaryDianChange(e, t) {
      const value = e.target.value;
      this.form[t] = value;
    },
    //关闭
    handleClose() {
      this.dialogVisible = false;
    },

    // 删除
    handleDelete(row) {
      console.log("删除", row);
      if (!row.length) {
        this.$message.error("至少选择一个");
        return;
      }
      this.$confirm("确定删除吗?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        firmwareDelete(row.map((obj) => obj.id).join(",")).then((res) => {
          if (res.code === 200) {
            this.$message.success("删除成功!");
            console.log(row, "rowrowrowrow");
            this.$refs.crud.toggleSelection();
            this.onLoad();
          }
        });
      });
    },
    //表格左侧选择的数据的
    selectionChange(list) {
      this.selectedRowKeys = list;
      // console.log('选中的数据',list);
      // this.$message.success('选中的数据'+ JSON.stringify(list));
    },

    handleCreate(row, type) {
      this.$router.push({
        path: "/upgrade/create",
        query: {
          id: row.id,
          type: type,
        },
      });
    },
  },
};
</script>

<style scoped>
.title {
  text-align: center;
}
.box_content {
  padding: 0 30px;
}
.box_item {
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 16px;
  margin-bottom: 30px;
  cursor: pointer;
}
.flex_echarts {
  display: flex;
  background: #373b47;
  padding: 0 15px;
}
.title_left {
  width: 5%;
  padding: 15px 0;
}
.left_name {
  height: 110px;
  line-height: 110px;
  color: #ffffff;
}
.echarts_left {
  width: 95%;
}
.fault_box {
  display: flex;
  align-items: center;
  margin-bottom: 15px;
}
.fault_box_label {
  margin-right: 10px;
}
</style>
